/* Automation Workflow Builder — triggers & actions catalogs.
   Each item: { key, label, category, color, icon ('trigger'|'send'|'wait'|'logic'|'opp'|'appt'|'ai'|'tkt'|'ctc'|'mkt'|'webhook'), pro?: true } */

export const TRIGGER_CATEGORIES = [
  { name: "Recent triggers", items: [
    "community_leaderboard_level::Community group member leaderboard level changed",
    "external_tracking_event::External tracking event",
  ]},
  { name: "Contact", items: [
    "birthday_reminder::Birthday reminder",
    "contact_changed::Contact changed",
    "contact_created::Contact created",
    "contact_dnd::Contact DND",
    "contact_tag::Contact tag",
    "custom_date_reminder::Custom date reminder",
    "note_added::Note added",
    "note_changed::Note changed",
    "task_added::Task added",
    "task_reminder::Task reminder",
    "task_completed::Task completed",
    "engagement_score::Contact engagement score",
  ]},
  { name: "Events", items: [
    "inbound_webhook::Inbound webhook|pro",
    "scheduler::Scheduler",
    "call_details::Call details",
    "email_events::Email events",
    "customer_replied::Customer replied",
    "inbound_email::Inbound email",
    "conv_ai_trigger::Conversation AI trigger",
    "custom_trigger::Custom trigger",
    "form_submitted::Form submitted",
    "survey_submitted::Survey submitted",
    "trigger_link_clicked::Trigger link clicked",
    "facebook_lead_form::Facebook lead form submitted",
    "tiktok_form::TikTok form submitted",
    "video_tracking::Video tracking",
    "number_validation::Number validation",
    "sms_error::Messaging error – SMS",
    "linkedin_lead_form::LinkedIn lead form submitted",
    "funnel_pageview::Funnel/website pageview",
    "quiz_submitted::Quiz submitted",
    "new_review::New review received",
    "prospect_generated::Prospect generated",
    "wa_click_ads::Click to WhatsApp ads",
  ]},
  { name: "Appointments", items: [
    "appointment_status::Appointment status",
    "appointment_booked::Customer booked appointment",
    "service_booking::Service booking",
    "rental_booking::Rental booking",
  ]},
  { name: "Opportunities", items: [
    "opportunity_status_changed::Opportunity status changed",
    "opportunity_created::Opportunity created",
    "opportunity_changed::Opportunity changed",
    "pipeline_stage_changed::Pipeline stage changed",
    "stale_opportunities::Stale opportunities",
  ]},
  { name: "Affiliate", items: [
    "affiliate_created::Affiliate created",
    "new_affiliate_sales::New affiliate sales",
    "affiliate_enrolled::Affiliate enrolled in campaign",
    "lead_created::Lead created",
  ]},
  { name: "Payments", items: [
    "invoice_paid::Invoice paid",
    "invoice_sent::Invoice sent",
    "payment_received::Payment received",
    "payment_failed::Payment failed",
    "subscription_created::Subscription created",
    "subscription_canceled::Subscription canceled",
  ]},
  { name: "Membership", items: [
    "course_offer_granted::Course offer granted",
    "course_offer_revoked::Course offer revoked",
    "lesson_completed::Lesson completed",
  ]},
  { name: "Conversation", items: [
    "new_inbound_message::New inbound message",
    "message_contains_keyword::Message contains keyword",
    "missed_call::Missed call",
    "voicemail_received::Voicemail received",
    "whatsapp_received::WhatsApp message received",
    "instagram_dm::Instagram DM received",
    "messenger_received::Facebook Messenger received",
    "live_chat_received::Live chat message received",
    "human_takeover::Human takeover requested",
  ]},
  { name: "Support", items: [
    "ticket_created::Ticket created",
    "ticket_status_changed::Ticket status changed",
    "ticket_priority_changed::Ticket priority changed",
    "ticket_assigned::Ticket assigned",
    "ticket_overdue::Ticket overdue",
    "ticket_resolved::Ticket resolved",
  ]},
  { name: "AI", items: [
    "ai_intent_detected::AI intent detected",
    "ai_human_takeover::AI human takeover triggered",
    "ai_extracted_data::AI extracted data",
    "ai_confidence_low::AI confidence below threshold",
    "ai_conversation_complete::AI conversation completed",
  ]},
];

export const ACTION_CATEGORIES = [
  { name: "Recent actions", items: ["wait::Wait"] },
  { name: "Contact", items: [
    "create_contact::Create contact",
    "find_contact::Find contact",
    "update_contact_field::Update contact field",
    "add_tag::Add contact tag",
    "remove_tag::Remove contact tag",
    "assign_user::Assign to user",
    "remove_assigned_user::Remove assigned user",
    "toggle_dnd::Enable/disable DND",
    "add_note::Add to notes",
    "copy_contact::Copy contact|pro",
    "edit_conversation::Edit conversation",
    "add_task::Add task",
    "delete_contact::Delete contact",
    "modify_engagement_score::Modify contact engagement score",
    "add_followers::Add contact followers",
    "remove_followers::Remove contact followers",
    "merge_contact::Merge contact",
    "email_verification::Email verification",
  ]},
  { name: "Communication", items: [
    "send_email::Send email",
    "send_sms::Send SMS",
    "slack::Slack|pro",
    "wa_window_check::WhatsApp: customer service window check",
    "wa_send_flows::WhatsApp: send flows",
    "send_live_chat::Send live chat message",
    "appt_booking_bot::Appointment booking conversation AI bot",
    "update_conv_ai::Update conversation AI bot and status",
    "book_appointment::Book appointment",
    "log_external_call::Log external call",
    "send_whatsapp::WhatsApp",
    "send_whatsapp_media::WhatsApp media",
    "send_whatsapp_interactive::WhatsApp interactive messages",
  ]},
  { name: "Send data", items: [
    "webhook::Webhook",
    "custom_webhook::Custom webhook|pro",
    "google_sheets::Google Sheets|pro",
  ]},
  { name: "Internal", items: [
    "if_else::If / else",
    "wait::Wait",
    "goal_event::Goal event",
    "split::Split",
    "update_custom_value::Update custom value",
    "go_to::Go to",
    "datetime_formatter::Date/time formatter",
    "number_formatter::Number formatter",
    "math_operation::Math operation",
    "set_event_start_date::Set event start date",
    "add_to_workflow::Add to workflow",
    "remove_from_workflow::Remove from workflow",
    "array_formatter::Array formatter",
    "drip::Drip",
  ]},
  { name: "Workflow AI", items: [
    "ai_agent::AI Agent|pro",
  ]},
  { name: "External AI models", items: [
    "ext_gpt::GPT powered by OpenAI|pro",
    "ext_claude::Claude powered by Anthropic|pro",
    "ext_deepseek::DeepSeek AI|pro",
    "ext_gemini::Gemini AI|pro",
  ]},
  { name: "AI Actions", items: [
    "ai_translate::AI translate|pro",
    "ai_summarize::AI summarize|pro",
    "ai_intent_detection::AI intent detection|pro",
    "ai_decision_maker::AI decision maker|pro",
    "ai_extract_data::AI extract data|pro",
  ]},
  { name: "Appointments", items: [
    "update_appointment_status::Update appointment status",
    "create_appointment_note::Create appointment / booking note",
    "generate_booking_link::Generate one time booking link",
  ]},
  { name: "Opportunity", items: [
    "create_update_opportunity::Create/update opportunity",
    "remove_opportunity::Remove opportunity",
    "add_owner_to_opportunity::Add owner to opportunity",
    "remove_owner_from_opportunity::Remove owner from opportunity",
    "add_followers_opp::Add follower(s) to opportunity",
    "remove_followers_opp::Remove follower(s) from opportunity",
    "find_opportunity::Find opportunity",
    "create_opportunity::Create opportunity",
    "update_opportunity::Update opportunity",
  ]},
  { name: "Payments", items: [
    "stripe_one_time::Stripe one time charge",
    "send_invoice::Send invoice",
    "send_estimate::Send estimate",
    "send_documents::Send documents & contracts",
    "send_recurring_invoice::Send recurring invoice",
  ]},
  { name: "Marketing", items: [
    "google_analytics::Add to Google Analytics",
    "google_ads::Add to Google Ads",
    "fb_add_audience::Facebook – Add to custom audience",
    "fb_remove_audience::Facebook – Remove from custom audience",
    "meta_conversion_api::Meta conversion API",
    "marketing_audit::Generate marketing audit report",
  ]},
  { name: "Membership", items: [
    "course_grant::Course grant offer",
    "course_revoke::Course revoke offer",
  ]},
  { name: "Support Tickets", items: [
    "create_ticket::Create ticket",
    "update_ticket::Update ticket",
    "assign_ticket::Assign ticket",
    "change_ticket_status::Change ticket status",
    "change_ticket_priority::Change ticket priority",
    "add_ticket_note::Add ticket note",
    "close_ticket::Close ticket",
    "reopen_ticket::Reopen ticket",
    "escalate_ticket::Escalate ticket",
  ]},
  { name: "Funding / Credit", items: [
    "send_funding_intake::Send funding intake form",
    "request_credit_access::Request credit report access",
    "request_documents::Request documents",
    "update_funding_readiness::Update funding readiness status",
    "assign_credit_specialist::Assign credit review specialist",
    "create_funding_opportunity::Create funding opportunity",
    "move_to_credit_review::Move to credit review stage",
    "move_to_ready_to_apply::Move to ready-to-apply stage",
    "send_secure_portal_link::Send secure portal link",
    "send_application_checklist::Send application checklist",
  ]},
];

// Map a node type → visual style (color tone + abstract icon key)
export const NODE_STYLE = {
  // triggers (green family)
  form_submitted:      { tone: "trigger", glyph: "📋" },
  facebook_lead_form:  { tone: "trigger", glyph: "📋" },
  appointment_booked:  { tone: "appt",    glyph: "📅" },
  customer_replied:    { tone: "trigger", glyph: "💬" },
  missed_call:         { tone: "trigger", glyph: "📞" },
  ticket_priority_changed: { tone: "tkt", glyph: "🎫" },
  ai_human_takeover:   { tone: "ai",      glyph: "🤖" },
  contact_tag:         { tone: "trigger", glyph: "🏷" },
  // actions
  send_sms:            { tone: "send",    glyph: "✉" },
  send_email:          { tone: "send",    glyph: "✉" },
  send_whatsapp:       { tone: "send",    glyph: "🟢" },
  wait:                { tone: "logic",   glyph: "⏱" },
  if_else:             { tone: "logic",   glyph: "⌬" },
  create_opportunity:  { tone: "opp",     glyph: "$" },
  create_update_opportunity: { tone: "opp", glyph: "$" },
  add_to_workflow:     { tone: "logic",   glyph: "≡" },
  add_tag:             { tone: "ctc",     glyph: "🏷" },
  update_contact_field:{ tone: "ctc",     glyph: "✎" },
  create_ticket:       { tone: "tkt",     glyph: "🎫" },
  book_appointment:    { tone: "appt",    glyph: "📅" },
  webhook:             { tone: "webhook", glyph: "🔗" },
  ai_decision_maker:   { tone: "ai",      glyph: "🤖" },
  ai_intent_detection: { tone: "ai",      glyph: "🤖" },
};

export const TONES = {
  trigger: { bg: "#DCFCE7", fg: "#15803D" },  // green
  send:    { bg: "#DCFCE7", fg: "#15803D" },
  appt:    { bg: "#DBEAFE", fg: "#1E40AF" },  // blue
  opp:     { bg: "#DBEAFE", fg: "#1E40AF" },
  tkt:     { bg: "#DBEAFE", fg: "#1E40AF" },
  ctc:     { bg: "#DBEAFE", fg: "#1E40AF" },
  logic:   { bg: "#EDE9FE", fg: "#6D28D9" },  // purple
  ai:      { bg: "#EDE9FE", fg: "#6D28D9" },
  webhook: { bg: "#DBEAFE", fg: "#1E40AF" },
  mkt:     { bg: "#FEF3C7", fg: "#92400E" },
};

export function flatList(catalog) {
  return catalog.flatMap((c) => c.items.map((s) => {
    const [key, rest] = s.split("::");
    const pro = (rest || "").endsWith("|pro");
    const label = (rest || "").replace(/\|pro$/, "");
    return { key, label, category: c.name, pro };
  }));
}
